<template>
  <div id="app">
    <header>
      <router-link :to="{'name': 'homepage'}" id="logo">Fortrand</router-link>
    </header>
    <nav id="main-menu">
      <span class="icon" :class="{'opened': show_main_menu}" @click="toggleMainMenu"></span>
      <ul v-if="show_main_menu">
        <router-link tag="li" :to="{'name': 'page', 'params': { 'slug': slug }}" v-for="(name, slug) in menu" :key="slug">{{ name }}</router-link>
      </ul>
    </nav>
    <ul id="games-list" class="content-wrapper">
      <router-link tag="li" v-for="game in games" :id="`menu-${game.code}-game`" :key="game.code" :to="{'name': game.code}" :title="game.description">
        <h2>{{ game.title }}</h2>
      </router-link>
    </ul>
    <div id="page" v-if="!tos_accepted" class="tos">
      <article>
        <h1>Terms of Service</h1>
        <div class="page-text">
          <p>Our advices and forecasts based on JavaScript function Math.rand(), so don't make serious decisions through this website - it would be foolish and even dangerous.</p>
          <p style="font-weight: bold;">We are not responsible for any results of usage of our website. You use our advices and forecasts for your risk.</p>
          <p style="color: #cc0000;">Please, leave this website, if you want to use it in any serious purposes.</p>
        </div>
        <div>
          <div class="tos-buttons">
            <button class="action-button" type="button" @click="accept_tos">Accept</button>
            <a class="decline-link" href="http://google.com">Decline</a>
          </div>
        </div>
      </article>
    </div>
    <router-view v-else />
  </div>
</template>

<script>

const GAMES = [
  {
    'code': 'fortune-teller',
    'title': 'Fortune teller',
    'description': 'Hazy answers to your questions.',
  },
  {
    'code': 'roulette',
    'title': 'American roulette',
    'description': 'Spin the ball around american roulette wheel.',
  },
  {
    'code': 'coin',
    'title': 'Heads or tails',
    'description': 'Flip the coin and see how it lands',
  },
  {
    'code': 'loto',
    'title': 'Bingo',
    'description': 'Get random numbers one by one',
  },
  {
    'code': 'russian',
    'title': 'Russian roulette',
    'description': 'Dangerous and crazy game. Do not play it. Especially with self-loading pistols.',
  },
  {
    'code': '8ball',
    'title': 'Magic 8-ball',
    'description': 'If you need express-answer to your question - magic 8-ball is the best choice. But remember - yes/no questions only.',
  },
  {
    'code': 'dices',
    'title': 'Dice',
    'description': 'Throw dice and get number from 1 to 6.',
  },
  {
    'code': 'cards',
    'title': 'Cards',
    'description': 'If you need some random cards just get them!',
  },
  {
    'code': 'cuckoo',
    'title': 'Cuckoo',
    'description': 'Ask cuckoo about your lifetime estimation.',
  },
];

const PAGES = {
  'about': 'About',
  'copyrights': 'Copyrights',
  'tos': 'Terms of Service',
};

export default {
  name: 'App',
  data: function () {
    return {
      'show_main_menu': false,
      'menu': PAGES,
      'games': GAMES,
      'tos_accepted': localStorage.getItem('tos') ? true : false,
    }
  },
  methods: {
    'toggleMainMenu': function () {
      this.$data.show_main_menu = !this.$data.show_main_menu;
    },
    'accept_tos': function () {
      localStorage.setItem('tos', '1');
      this.$data.tos_accepted = true;
    },
  }
}
</script>

<style src="./assets/css/app.css"></style>
<style src="./assets/css/page.css" scoped></style>
